import(/* webpackMode: "eager", webpackExports: ["FullPageLoading"] */ "/home/runner/work/frontend-monorepo/frontend-monorepo/apps/curology-sign-up/src/components/global/FullPageLoading.tsx");
